import { useState } from 'react';
import { toast } from 'sonner';
import { Button } from '../ui/button';

// Aviso e botão do vinho em Aguardando estoque (regra em acionarFlavia.js): abre o texto pronto
// para o zap da Flávia. Só mostra e copia; não grava nada nem manda mensagem.
// Sem `podeAcionar` (o atendente), fica só o aviso: quem aciona a Flávia é a gestão.
export default function CardVinhoFlavia({ texto, podeAcionar = false }) {
  const [aberto, setAberto] = useState(false);
  if (!texto) return null;

  if (!podeAcionar) {
    return (
      <div className="mt-2 rounded-md border border-purple-300 bg-purple-50 dark:bg-purple-950/40 dark:border-purple-800 px-3 py-2" data-testid="acionar-flavia">
        <p className="text-xs font-medium text-purple-800 dark:text-purple-300 m-0">Vinho em Aguardando estoque: é com a Flávia. A gestão aciona.</p>
      </div>
    );
  }

  const copiar = () => {
    if (!navigator.clipboard) { toast.error('Selecione o texto e copie com Ctrl+C'); return; }
    navigator.clipboard.writeText(texto)
      .then(() => toast.success('Texto copiado'))
      .catch(() => toast.error('Selecione o texto e copie com Ctrl+C'));
  };

  return (
    <div className="mt-2 rounded-md border border-purple-300 bg-purple-50 dark:bg-purple-950/40 dark:border-purple-800 px-3 py-2 space-y-2" data-testid="acionar-flavia">
      <p className="text-xs font-medium text-purple-800 dark:text-purple-300 m-0">Vinho em Aguardando estoque: é com a Flávia.</p>
      {!aberto ? (
        <Button type="button" size="sm" onClick={() => setAberto(true)} data-testid="btn-acionar-flavia">Acionar Flávia</Button>
      ) : (
        <>
          <textarea
            readOnly
            value={texto}
            onFocus={(e) => e.target.select()}
            rows={6}
            className="w-full text-xs font-mono rounded border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-950 p-2"
            aria-label="Texto pronto para a Flávia"
          />
          <div className="flex flex-wrap gap-2">
            <Button type="button" size="sm" onClick={copiar}>Copiar</Button>
            <Button type="button" size="sm" variant="ghost" onClick={() => setAberto(false)}>Fechar</Button>
          </div>
          <p className="text-[11px] text-muted-foreground m-0">O ELO não manda nada: você copia e envia no zap da Flávia.</p>
        </>
      )}
    </div>
  );
}
